export const quoteCardBackgroundColor = `linear-gradient(130deg, #432699 0%, #1E0056 100%)`
